import { TicketActivitiesTypes } from "redux/actions/ticketActivitiesAction";

const defaultState = {
    dataOpenActivities: {},
};

const ticketActivitiesReducer = (state = defaultState, action: any) => {
    const { dataOpenActivities } = action;

    switch(action.type){
        case TicketActivitiesTypes.GET_OPEN_SUPPORT_ACTIVITIES_SUCCESS:
            return {
                ...state,
                dataOpenActivities,
            }
    }
    
    return state;
}

export default ticketActivitiesReducer;
